import { CONTATO } from "@/data/acomodacoes";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0f1f17] text-[#cfd8c9]">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <p className="text-[15vw] font-bold leading-none tracking-[-0.06em] text-[#1d3a2c] lg:text-[11rem]">quinta dos pinhais</p>
      <div className="mt-12 flex flex-col gap-8 border-t border-[#2c4a3b] pt-8 md:flex-row md:items-center md:justify-between">
        <Logo light />
        <div className="space-y-1 text-sm">
          <p>{CONTATO.endereco}</p>
          <p>
            {CONTATO.telefone} · {CONTATO.email}
          </p>
          <p data-testid="footer-cnpj">CNPJ {CONTATO.cnpj}</p>
        </div>
      </div>
    </div>
  </footer>
);
